import React from 'react';
import styled from 'styled-components';
import { FaCheckCircle, FaEnvelope } from 'react-icons/fa';

const Container = styled.div`
  max-width: 500px;
  margin: 0 auto;
  padding: 2rem;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  text-align: center;
`;

const Title = styled.h2`
  margin-bottom: 1.5rem;
  color: #333;
  font-size: 1.8rem;
`;

const SuccessIcon = styled(FaCheckCircle)`
  color: #4caf50;
  font-size: 4rem;
  margin-bottom: 1.5rem;
`;

const EmailIcon = styled(FaEnvelope)`
  color: #0084ff;
  font-size: 2rem;
  margin-right: 0.5rem;
  vertical-align: middle;
`;

const Message = styled.div`
  margin-bottom: 1.5rem;
  font-size: 1.1rem;
  line-height: 1.6;
  color: #555;
`;

const EmailHighlight = styled.div`
  background-color: #f5f8fd;
  padding: 1rem;
  border-radius: 4px;
  margin: 1.5rem 0;
  border-left: 4px solid #0084ff;
`;

const Button = styled.button`
  padding: 0.75rem 1.5rem;
  background-color: #0084ff;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
  margin-top: 1rem;
  
  &:hover {
    background-color: #0073e6;
  }
`;

const RegistrationSuccess = ({ email, onContinue }) => {
  return (
    <Container>
      <SuccessIcon />
      <Title>Registration Successful!</Title>
      
      <Message>
        Your account has been created successfully. Before you can start using our platform, 
        you need to verify your email address.
      </Message>
      
      <EmailHighlight>
        <EmailIcon /> We've sent a verification link to:
        <div style={{ fontWeight: 'bold', marginTop: '0.5rem' }}>{email}</div>
      </EmailHighlight>
      
      <Message>
        Please check your inbox (and spam folder) and click on the verification link 
        to activate your account.
      </Message>
      
      <Button onClick={onContinue}>
        Continue to Login
      </Button>
    </Container>
  );
};

export default RegistrationSuccess;
